/**
 * Diagnosis Service
 * Patient diagnosis tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { DiagnosisTypeRecommendationResponseDto } from '../model/diagnosisTypeRecommendationResponseDto';
// @ts-ignore
import { DiagnosisTypesControllerGetById200Response } from '../model/diagnosisTypesControllerGetById200Response';
// @ts-ignore
import { DiagnosisTypesControllerList200Response } from '../model/diagnosisTypesControllerList200Response';
// @ts-ignore
import { RecommendDiagnosisTypesRequestDto } from '../model/recommendDiagnosisTypesRequestDto';
// @ts-ignore
import { SearchDiagnosisTypesResponseDto } from '../model/searchDiagnosisTypesResponseDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class DiagnosisTypesService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Get diagnosis type definition
   * @param elementId 
   */
  public async diagnosisTypesControllerGetById(elementId: string, ): Promise<DiagnosisTypesControllerGetById200Response> {
    if (elementId === null || elementId === undefined) {
      throw new Error('Required parameter elementId was null or undefined when calling diagnosisTypesControllerGetById.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/types/${this.configuration.encodeParam({name: "elementId", value: elementId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List diagnosis type definitions
   * @param status Filter by status
   * @param search Search by display name
   * @param limit Number of items to return
   * @param offset Number of items to skip
   * @param groupId Filter by group ID
   * @param expand Fields to expand in the response
   */
  public async diagnosisTypesControllerList(status?: 'draft' | 'active' | 'inactive', search?: string, limit?: number, offset?: number, groupId?: string, expand?: Array<'groups'>, ): Promise<DiagnosisTypesControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (status !== undefined && status !== null) {
      localVarQueryParameters.append('status', String(status));
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters.append('search', String(search));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }
    if (groupId !== undefined && groupId !== null) {
      localVarQueryParameters.append('groupId', String(groupId));
    }
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/types?${queryString}` : `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/types`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get recommended diagnosis types for a patient
   * @param recommendDiagnosisTypesRequestDto 
   */
  public async diagnosisTypesControllerRecommendDiagnosisTypes(recommendDiagnosisTypesRequestDto: RecommendDiagnosisTypesRequestDto, ): Promise<Array<DiagnosisTypeRecommendationResponseDto>> {
    if (recommendDiagnosisTypesRequestDto === null || recommendDiagnosisTypesRequestDto === undefined) {
      throw new Error('Required parameter recommendDiagnosisTypesRequestDto was null or undefined when calling diagnosisTypesControllerRecommendDiagnosisTypes.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/types/recommend`,
        data: recommendDiagnosisTypesRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Search diagnosis types using Azure AI Search
   * @param q Search query string
   * @param page Page number (1-based)
   * @param limit Results per page
   * @param expand Fields to expand in the response
   */
  public async diagnosisTypesControllerSearch(q: string, page?: number, limit?: number, expand?: Array<'groups'>, ): Promise<SearchDiagnosisTypesResponseDto> {
    if (q === null || q === undefined) {
      throw new Error('Required parameter q was null or undefined when calling diagnosisTypesControllerSearch.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (q !== undefined && q !== null) {
      localVarQueryParameters.append('q', String(q));
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters.append('page', String(page));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/types/search?${queryString}` : `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/types/search`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
